module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-nissan.f7f32b36.png";